export const DAO_CODE = 'DASHBOARD_CONSULTANT_PRODUCTION' + '_DAO';
